<template>
  <div>
    <b-row>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading-card />
      </b-col>
      <b-col
        cols="12"
        md="7"
      >
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            <default-card
              title="Satış Şikayetleri"
              :value="overviews.complaints.sales"
              icon="InfoIcon"
              color="info"
              to-page="/crm/sales"
            />
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <default-card
              title="Servis Şikayetleri"
              :value="overviews.complaints.services"
              icon="InfoIcon"
              color="info"
              to-page="/crm/services"
            />
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <default-card
              title="Filo Şikayetleri"
              :value="overviews.complaints.rentals"
              icon="InfoIcon"
              color="info"
              to-page="/crm/rentals"
            />
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <default-card
              title="İkinci El Şikayetleri"
              :value="overviews.complaints.secondHands"
              icon="InfoIcon"
              color="info"
              to-page="/crm/second-hands"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col
        cols="12"
        md="5"
      >
        <pie-charts
          v-if="overviews.chartData.labels.length"
          :categories-data="overviews.chartData.labels"
          :series-data="overviews.chartData.series"
          chart-type="donut"
          chart-title="Şikayet Oranları"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import DefaultCard from '@/layouts/components/ReportCards/DefaultCard.vue'
import PieCharts from '@/layouts/components/ReportCharts/PieCharts.vue'

export default {
  name: 'IndexPage',
  components: {
    BRow,
    BCol,
    LoadingCard,
    DefaultCard,
    PieCharts,
  },
  computed: {
    loading() {
      return this.$store.getters['crmOverviewsReports/loading']
    },
    overviews() {
      return this.$store.getters['crmOverviewsReports/overviews']
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('crmOverviewsReports/getData')
    },
  },
}
</script>
